import { createGlobalStyle } from 'styled-components';

import { color, font } from '../../styles/constants';

export const DayPickerStyles = createGlobalStyle`
  .DayPicker {
    display: inline-block;
    font-size: 1rem;
    border-radius: 5px;
    font-weight: ${font.mediumWeight};
  }
  
  .DayPicker-wrapper {
    position: relative;
  
    flex-direction: row;
    padding-bottom: 1em;
  
    -webkit-user-select: none;
  
    -moz-user-select: none;
  
    -ms-user-select: none;
  
    user-select: none;
  }
  
  .DayPicker-Months {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .DayPicker-Month {
    display: table;
    margin: 0 1em;
    margin-top: 1em;
    border-spacing: 0;
    border-collapse: collapse;
  
    -webkit-user-select: none;
  
    -moz-user-select: none;
  
    -ms-user-select: none;
  
    user-select: none;
  }

  .DayPicker-Caption {
    display: none;
  }
  
  .DayPicker-Weekdays {
    display: table-header-group;
    margin-top: 1em;
  }
  
  .DayPicker-WeekdaysRow {
    display: table-row;
  }
  
  .DayPicker-Weekday {
    display: table-cell;
    padding: 0.852rem;
    color: ${color.white};
    font-weight: ${font.mediumWeight};
    font-size: 0;
    text-align: center;
  }
  
  .DayPicker-Weekday:first-letter {
    font-size: 1rem;
  }
  
  .DayPicker-Weekday abbr[title] {
    border-bottom: none;
    text-decoration: none;
  }
  
  .DayPicker-Body {
    display: table-row-group;
  }
  
  .DayPicker-Week {
    display: table-row;
  }
  
  .DayPicker-Day {
    display: table-cell;
    padding: 0.852rem;
    color: ${color.white};
    border-radius: 50%;
    vertical-align: middle;
    text-align: center;
    cursor: pointer;
    outline: none;
  }
  
  .DayPicker-WeekNumber {
    display: table-cell;
    padding: 0.5em;
    min-width: 1em;
    border-right: 1px solid #EAECEC;
    color: #8B9898;
    vertical-align: middle;
    text-align: right;
    font-size: 0.75em;
    cursor: pointer;
  }
  
  .DayPicker--interactionDisabled .DayPicker-Day {
    cursor: default;
  }
  
  .DayPicker-Footer {
    padding-top: 0.5em;
  }
  
  .DayPicker-Day--selected {
    background-color: ${color.blueLagoon};
  }
   .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    background-color: ${color.blueLagoon};
  }
  .DayPicker-TodayButton {
    border: none;
    background-color: transparent;
    background-image: none;
    box-shadow: none;
    color: #4A90E2;
    font-size: 0.875em;
    cursor: pointer;
  }
  
  /* Default modifiers */
  
  .DayPicker-Day--disabled {
    opacity: 0.4;
  }
  
  /* Example modifiers */
  
  .DayPicker-Day--sunday {
    background-color: #F7F8F8;
  }
  
  .DayPicker-Day--sunday:not(.DayPicker-Day--today) {
    color: #DCE0E0;
  }
  
  .DayPicker:not(.DayPicker--interactionDisabled)
  .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
    font-weight: ${font.mediumWeight}
    background-color: ${color.pelorous};
    color: ${color.white};
  }
  
  /* DayPickerInput */
  
  .DayPickerInput {
    display: inline-block;
  }
  
  .DayPickerInput-OverlayWrapper {
    position: relative;
  }
  
  .DayPickerInput-Overlay {
    position: absolute;
    left: 0;
    z-index: 1;
  
    background: white;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  }
  
  @media (min-width: 1024px) {
    .DayPicker {
      font-size: ${font.size13};
      border-radius: 5px;
      font-weight: ${font.lightWeight};
      position: absolute;
      top: 32px;
      left: 55%;
      background-color: ${color.white};
      box-shadow: 0 5px 5px ${color.boxShadow};
    }
    .DayPicker-Weekday {
      color: ${color.grey5};
      padding: 9px;
    }  
    .DayPicker-Weekday:first-letter {
      font-size: ${font.size13};
    }    
    .DayPicker-Day--today {
      color: ${color.pelorous};
    }
    .DayPicker-Day--selected {
      background-color: ${color.white};
    }
    .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
      position: relative;
      background: none;
      color: ${color.pelorous};
    }
    .DayPicker-Day {
      color: ${color.grey5};
      padding: 9px;
    }
  }
`;
